module.exports = __webpack_public_path__ + "img/xiaozi_pingtai.fc124d61.jpg";